<template>
  <div >
    <a-row class="allbody">
      <a-col :md="24">
        <img src="~@/assets/imgs/mianlogo.jpg" class="imgs"/>
<!--        <div style="float: left;margin-top: -55%;margin-left: 8%;">
          <a-button type="link"> <img src="~@/assets/imgs/logoone.png" style="width: 140px;height: 30px;"/></a-button>
        </div>-->
        <div style="margin-top: -55%;float: right;margin-right: 8%;">
          <router-link to='/'><a-button type="link" style="font-weight: bold;color: rgba(255,255,255,10)">首页</a-button></router-link>
          <router-link to='/productintr'><a-button type="link" style="color: rgba(255,255,255,10)">产品介绍</a-button></router-link>
          <router-link to='/aboutus'><a-button type="link"  style="color: rgba(255,255,255,10)">关于我们</a-button></router-link>
          <router-link to='/caseinfo'><a-button type="link"  style="color: rgba(255,255,255,10)">业绩案例</a-button></router-link>
          <router-link to='/contantus'><a-button shape="round">联系我们</a-button></router-link>
        </div>
        <div style="float: left;margin-left: 8%;margin-top: -38%;">
          <a-button type="link" style="color: white;font-size: 40px;font-weight: bold;text-align: left;">
            <div>特种设备智能管理<br/>解决方案</div>
            <div style="font-size: 18px;font-weight: normal;">物联网 大数据 云计算 机器智能</div>
          </a-button>
          <br/>
        </div>
      </a-col>
      <a-col :md="24">
        <div style="text-align: center;">
          <p style="color: rgba(16, 16, 16, 100);font-size: 40px;font-weight: bold;margin-top: 5%">专业、稳健、便捷、易用</p>
        </div>
        <div style="text-align: center;">
          <a-card class="cards" style="margin-right: 32px;" hoverable>
            <img src="~@/assets/imgs/dt.png" width="50" style="margin-bottom: 10px"/>
            <p class="pfont1">电梯管理系统</p>
            <p class="pfont2">电梯保险+服务+科技</p>
            <p class="pfont2">梯云星电梯智能机器人</p>
            <p class="pfont2">电梯安全远程监控系统应用云平台</p>
          </a-card>
          <a-card class="cards" style="margin-right: 32px;" hoverable>
            <img src="~@/assets/imgs/tam.png" width="50" style="margin-bottom: 10px"/>
            <p class="pfont1">特安码平台</p>
            <p class="pfont2">特种设备安全码综合服务平台，实现</p>
            <p class="pfont2">特种设备安全码的自动化赋码，码</p>
            <p class="pfont2">管理，服务应用，管理应用。</p>
          </a-card>
          <a-card class="cards" hoverable>
            <img src="~@/assets/imgs/zt.png" width="50" style="margin-bottom: 10px"/>
            <p class="pfont1">特种设备信息化中台</p>
            <p class="pfont2">维保备案及审核；检测备案及审核；</p>
            <p class="pfont2">按需维保申请及审批；按需维保日常</p>
            <p class="pfont2">运行。建立电梯、气瓶风险分析。</p>
          </a-card>
          <br/>
          <a-card class="cards" style="margin-right: 32px;" hoverable>
            <img src="~@/assets/imgs/gg.png" width="50" style="margin-bottom: 10px"/>
            <p class="pfont1">公共安全服务平台</p>
            <p class="pfont2">对采集的数据进行多维度分析，为不</p>
            <p class="pfont2">同类型用户提供适配的功能界面，助</p>
            <p class="pfont2">力提升协同管理效率。</p>
          </a-card>
          <a-card class="cards" style="margin-right: 32px;" hoverable>
            <img src="~@/assets/imgs/ym.png" width="50" style="margin-bottom: 10px"/>
            <p class="pfont1">镜面云码</p>
            <p class="pfont2">在普通二维码基础上增加镜面防伪功</p>
            <p class="pfont2">能，解决特种设备对数据真实性、可</p>
            <p class="pfont2">追溯性及全过程防伪的基本要求。</p>
          </a-card>
          <a-card class="cards"  hoverable>
            <img src="~@/assets/imgs/yf.png" width="50" style="margin-bottom: 10px"/>
            <p class="pfont1">研发能力</p>
            <p class="pfont2">物联网硬件研发</p>
            <p class="pfont2">软硬件高效结合</p>
            <p class="pfont2">网络安全控制</p>
          </a-card>
        </div>
      </a-col>
      <a-col :md="24">
        <div style="width: 80px;height:80px;background-color: rgba(59, 67, 242, 100);border-radius: 50%;margin: 0 auto;margin-bottom: 5%;"> </div>
        <a-row>
          <a-col :md="2"></a-col>
          <a-col :md="8">
            <div style="padding-left: 20%">
              <div style="color: rgba(16, 16, 16, 100);font-size: 25px;font-weight: bold;margin-bottom: 10%">核心技术</div>
              <div style="margin-bottom: 10%">
                <span style="color: rgba(16, 16, 16, 100);font-size: 14px;opacity: 0.5;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;">
                  大数据分析云，对各个关键风险控制节点进行分析。<br/>
                  多年行业经验，健全的分析数模，多技术平台，<br/>
                  支持跨数据库多维度运算
                </span>
              </div>
              <div style="width: 240px;height: 60px;line-height: 60px;border-radius: 8px;text-align: left;box-shadow: 10px 20px 60px 0px rgba(0, 0, 0, 0.12);padding-left: 5%;margin-bottom: 4%">
                <img src="~@/assets/imgs/ymhx.png" width="30"/>
                <span style="padding-left: 5%;color: #233D63;font-family: SourceHanSansSC-regular;font-size: 16px">镜面云码</span>
              </div>
              <div style="width: 240px;height: 60px;line-height: 60px;border-radius: 8px;text-align: left;box-shadow: 10px 20px 60px 0px rgba(0, 0, 0, 0.12);padding-left: 5%;margin-left: 10%;">
                <img src="~@/assets/imgs/ggaqdt.png" width="30"/>
                <span style="padding-left: 5%;color: #233D63;font-family: SourceHanSansSC-regular;font-size: 16px">公共安全服务平台</span>
              </div>
              <div style="width: 240px;height: 60px;line-height: 60px;border-radius: 8px;text-align: left;box-shadow: 10px 20px 60px 0px rgba(0, 0, 0, 0.12);padding-left: 5%;margin-bottom: 4%;margin-top: 4%">
                <img src="~@/assets/imgs/wlw.png" width="30"/>
                <span style="padding-left: 5%;color: #233D63;font-family: SourceHanSansSC-regular;font-size: 16px">物联网设备</span>
              </div>
            </div>
          </a-col>
          <a-col :md="3"></a-col>
          <a-col :md="6">
            <img src="~@/assets/imgs/cm.jpg" width="400"/>
          </a-col>
        </a-row>
      </a-col>
      <a-col :md="24">
        <div style="margin-top: 5%"></div>
        <div style="width: 80px;height:80px;background-color: rgba(59, 67, 242, 100);border-radius: 50%;margin: 0 auto;margin-bottom: 5%"> </div>
        <a-row>
          <a-col :md="14">
            <div class="nextxm">

            </div>
          </a-col>
          <a-col :md="6">
            <div style="text-align: left">
              <div style="color: rgba(16, 16, 16, 100);font-size: 25px;font-weight: bold;margin-bottom: 25%">研发能力</div>
              <div style="opacity: 0.5;color: rgba(16, 16, 16, 100);font-size: 14px;width: 350px;text-indent: 2em">
                公司拥有由行业顾问与研发工程师组成的技术团队，持续开展立体云码、电梯中台技术、电梯安全云、
                电梯物联网设备、气瓶充装管理系统、特种设备检验检测信息化平台等相关产品与技术研发，
                围绕城市安全与公共服务等应用场景，为政府部门、生产企业、维保企业、使用单位及系统建设方
                提供技术研发与服务支持。
              </div>
            </div>
          </a-col>
        </a-row>
      </a-col>
      <a-col :md="24">
        <div style="background-color: #ecf5ff;color: rgba(16, 16, 16, 100);font-size: 14px;text-align: center;margin-top: 5%;padding-top:6%">
          <div style="color: rgba(16, 16, 16, 100);font-size: 25px;font-weight: bold;margin-bottom:2%">企业理念</div>
          <a-row>
            <a-col :md="6">
              <div class="cards2" >
                <img src="~@/assets/imgs/ln.png" width="60" style="margin-bottom: 20px"/>
                <p class="pfont11">从客户需求出发</p>
                <div class="pfont22">进行设计、研发、生产，提供满足客户需求的产品方案</div>
              </div>
            </a-col>
            <a-col :md="6">
              <div class="cards2">
                <img src="~@/assets/imgs/ln.png" width="60" style="margin-bottom: 20px"/>
                <p class="pfont11">坚持科学工程方法</p>
                <div class="pfont22">深度运用物联网智能采集技术、大数据分析等科学方法，赋能特种设备行业，使行业更加健康有序发展</div>
              </div>
            </a-col>
            <a-col :md="6">
              <div class="cards2">
                <img src="~@/assets/imgs/ln.png" width="60" style="margin-bottom: 20px"/>
                <p class="pfont11">坚持不懈的奋斗</p>
                <div class="pfont22">秉承奋斗者精神，持续奋斗，新特种设备物联网事业的可持续发展而不懈努力</div>
              </div>
            </a-col>
            <a-col :md="6">
              <div class="cards2">
                <img src="~@/assets/imgs/ln.png" width="60" style="margin-bottom: 20px"/>
                <p class="pfont11">持续深耕核心技术</p>
                <div class="pfont22">深入特种设备领域研究，坚持自主开发，持续打磨相关技术能力，推动行业数字化发展</div>
              </div>
            </a-col>
          </a-row>
        </div>
      </a-col>
      <a-col :md="24">
        <foot-boot1 />
      </a-col>
    </a-row>
    <a-back-top />
  </div>
</template>

<script>
  import footBoot1 from './footboot1'
  export default {
    name: 'Website',
    components: {
      footBoot1
    },
    data () {
      return {
        scaleW: 1,
        scaleH: 1,
        size:50,
      }
    },
    created(){

    },
    methods: {

    }
  }
</script>
<style>
  .anchorBL {
    display: none;
  }
  .BMap_cpyCtrl .BMap_noprint .anchorBL {
    display: none;
  }
</style>
<style scoped>
  .imgs{
    z-index: -1;
    height: auto;
    max-width: 100%;
    display: block;
  }
  .allbody{
    position: relative;
    max-width: 1920px;
    width: 100%;
    margin: 0 auto;
  }
  .contant{
    color: rgba(255, 255, 255, 100);
    margin-left: 10%;
    margin-top: -43%;
    text-align: left;
  }
  .onep{
    font-size: 45px;
    font-family: SourceHanSansSC-bold;
    font-weight: bold;
    }
  .twop{
    font-size: 16px;
    font-family: SourceHanSansSC-regular;
  }
  .cards{
    width: 28%;
    display: inline-block;
    margin-bottom: 60px;
    border: none;
    text-overflow:ellipsis;
    overflow:hidden;
    white-space:nowrap;
    box-shadow: 0px 10px 20px 0px rgb(231 238 247);
    background-color: rgba(255, 255, 255, 100);
  }
  .pfont1{
    color: rgba(16, 16, 16, 100);
    font-size: 24px;
    font-weight: bold;
    opacity: 0.9;
  }
  .pfont2{
    color: rgba(16, 16, 16, 100);
    font-size: 14px;
    opacity: 0.5;
  }
  .nextxm{
    background: url('~@/assets/imgs/mianlsls.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 450px;
    height: 450px;
    margin-left: 15%;
    text-align: center;
  }
  .divs{
    width: 140px;
    height: 230px;
    background-color: rgba(255, 255, 255, 100);
    border-radius: 8px;
    text-align: center;
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.2);
    margin-right: 5%;
    margin-top: 20%;
    padding: 10px;
  }
  .cards2{
    margin-bottom: 10%;
    text-align: center;
    margin-left: 20px;
    height: 280px;
  }
  .pfont11{
    color: rgba(16, 16, 16, 100);
    font-size: 20px;
    font-weight: bold;
    opacity: 0.9;
  }
  .pfont22{
    color:#101010;
    font-size: 16px;
    width: 100%;
    padding: 0 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Website.vue